'use strict';

var __makeTemplateObject =
  (void 0 && (void 0).__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', {
        value: raw,
      });
    } else {
      cooked.raw = raw;
    }

    return cooked;
  };

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.StyledSVG = void 0;

var styled_components_1 = __importDefault(require('styled-components'));

exports.StyledSVG = styled_components_1.default.svg(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  display: inline-block;\n  user-select: none;\n  fill: ', ';\n'],
      ['\n  display: inline-block;\n  user-select: none;\n  fill: ', ';\n']
    )),
  function (_a) {
    var fill = _a.fill,
      theme = _a.theme;
    return fill ? '' : theme.transparent[100];
  }
);
var templateObject_1;
